import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { OtpModalService } from '../shared/modal/otp-modal.service';

@Injectable()
export class OtpInterceptor implements HttpInterceptor {
  private failedRequest: HttpRequest<any> | null = null; // Variable to store failed request
  constructor(private otpService: OtpModalService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // 🛠️ Retrieve OTP from localStorage (or other storage)
    const otp = localStorage.getItem('OTP');
    // 📨 Clone request and add OTP to headers (if available)
    const clonedRequest = otp
      ? req.clone({
        setHeaders: { 'security-code': otp }
      })
      : req;
    return next.handle(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 423) { // 423 

          // Cache the failed request for logging
          this.failedRequest = req;
          this.otpService.openOtp(this.failedRequest); // Open modal & send API data
        }
        return throwError(() => error); // Propagate error
      })
    );
  }
}
